"use client";

import React, { useState, useEffect } from "react";
import ModalGalleryItem from "./ModalGalleryItem";
import Image from "next/image";
import { getImageURL } from "@/helpers/imageURLHelper";

const GalleryLockup = ({ title, images, galleryItemsId, lockup_format }) => {
  const [openGalleryImage, setOpenGalleryImage] = useState(false);
  const [defaultImage, setDefaultImage] = useState(false);
  const [defaultIndex, setDefaultIndex] = useState(false);

  useEffect(() => {
    const closeOnEscapePressed = (e) => {
      if (e.key === "Escape") {
        setOpenGalleryImage(false);
      }
    };
    window.addEventListener("keydown", closeOnEscapePressed);
    return () => window.removeEventListener("keydown", closeOnEscapePressed);
  }, []);

  const handleCarouselOpenGalleryImage = (e, index) => {
    e.preventDefault();
    setOpenGalleryImage(!openGalleryImage);
    setDefaultImage(images.data[index].attributes);
    setDefaultIndex(index);
  };

  const handleImageChange = (e, direction) => {
    e.preventDefault();

    if (direction === "next") {
      if (defaultIndex < images.data.length - 1) {
        setDefaultIndex(defaultIndex + 1);
        setDefaultImage(images.data[defaultIndex + 1].attributes);
      } else {
        setDefaultIndex(0);
        setDefaultImage(images.data[0].attributes);
      }
    } else {
      if (defaultIndex == 0) {
        setDefaultIndex(images.data.length - 1);
        setDefaultImage(images.data[images.data.length - 1]?.attributes);
      } else {
        setDefaultIndex(defaultIndex - 1);
        setDefaultImage(images.data[defaultIndex - 1].attributes);
      }
    }
  };

  let styles = [];

  if (lockup_format == 5) {
    styles = [
      { backgroundPosition: "0% 52%" },
      { backgroundPosition: "61% 0%" },
      { backgroundPosition: "0% 0%" },
      { backgroundPosition: "50% 0%" },
      { backgroundPosition: "51% 0%" },
      { backgroundPositionY: "0%", backgroundPositionX: "31%" },
    ];
  } else if (lockup_format == 6) {
    styles = [
      { backgroundPosition: "0% 0%" },
      { backgroundPosition: "50% 0%" },
      { backgroundPosition: "0% 0%" },
      { backgroundPosition: "0% 0%" },
      { backgroundPosition: "50% 0%" },
      { backgroundPosition: "50% 0%" },
    ];
  }

  return (
    <div
      className={`tps-gallery-lockup-wrapper tps-lockup-${lockup_format}-up`}
    >
      <div className="tps-gallery-lockup">
        {images.data.map((item, index) => {
          const imageAttributes = item?.attributes;

          const imageUrl = getImageURL(
            imageAttributes?.formats?.large?.url || imageAttributes.url
          );

          return (
            <a
              key={index}
              className={`tps-gallery-item tps-gallery-lockup-item tps-gallery-lockup-item-${
                index + 1
              } odd`}
              href="#"
              title={`${title} ${index + 1}`}
              data-gallery-array-id={`galleryItems_${galleryItemsId}`}
              data-item-id={`${title}-${index + 1}`}
              data-item-index={`${index}`}
              onClick={() => {
                handleCarouselOpenGalleryImage(event, index);
              }}
            >
              <span className="tps-gallery-lockup-item-inner">
                <Image
                  src={`${imageUrl}`}
                  className="tps-gallery-lockup-image hide lazyload"
                  alt={`${title}-${index + 1}`}
                  width={
                    imageAttributes?.formats?.small?.width ||
                    imageAttributes.width
                  }
                  height={
                    imageAttributes?.formats?.small?.height ||
                    imageAttributes.height
                  }
                />

                <span
                  className="tps-gallery-lockup-image-bg lazyloaded"
                  data-bg={`${imageUrl}`}
                  style={{
                    ...styles[index],
                    backgroundImage: `url(${imageUrl})`,
                  }}
                ></span>
              </span>
            </a>
          );
        })}
      </div>
      {openGalleryImage && (
        <ModalGalleryItem
          image={defaultImage}
          index={defaultIndex}
          display={openGalleryImage}
          handleImageChange={handleImageChange}
          onClose={() => setOpenGalleryImage(false)}
        />
      )}
    </div>
  );
};

export default GalleryLockup;
